import { useState } from "react";

import { VatCodeEditForm } from "src/app/features/VatCode/components/forms/VatCodeEditForm";
import { ActionBar } from "../../../../components/ActionBar/ActionBar";
import { PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { FPage, FPageContent, FPageHeader } from "../../../../components/AppLayout/components/FPageLayout";
import { BackButton } from "../../../../components/FeatureButtons/BackButton";
import { SubmitButton } from "../../../../components/FeatureButtons/SubmitButton";
import { canAccess } from "../../../../core/router/auth/permissions";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import { BASE_PATH } from "../../../../core/router/types/routerTypes";

export const VatCodeEditFormPage = () => {
    const [runSubmit, setRunSubmit] = useState(0);
    const triggerFormSubmit = () => setRunSubmit(runSubmit + 1);
    const hasWriteAccess = canAccess(ResourceName.VAT_CODES, "basicTabsWrite");

    return (
        <FPage>
            <FPageHeader>
                <PageTitle translationKey="page.title.VatCodeEditFormPage" />
                <ActionBar>
                    <SubmitButton isDisabled={!hasWriteAccess} onClick={triggerFormSubmit} />
                    <BackButton isDisabled={false} url={`${BASE_PATH}/${ResourceName.VAT_CODES}`} />
                </ActionBar>
            </FPageHeader>
            <FPageContent>
                <VatCodeEditForm runSubmit={runSubmit} />
            </FPageContent>
        </FPage>
    );
};
